import { connect } from 'react-redux';

import {
  institutionsGetAll,
} from '../../actions/institutionActions';

import InstitutionList from './InstitutionList';

const mapStateToProps = state => ({
  ...state.institutionReducer,
});

const mapDispatchToProps = {
  institutionsGetAll,
};

export default connect(mapStateToProps, mapDispatchToProps)(InstitutionList);
